import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AUTOMATION_RUN_STATS_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_automation_runs_stats_url } from '@/utils/urls.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { RunsStats } from '@/types/runs.ts';

const useRetrieveProjectRunStats = (): UseQueryResult<RunsStats, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: AUTOMATION_RUN_STATS_KEY(automationId),
    queryFn: async () => {
      const response = await apiClient.get(get_automation_runs_stats_url(automationId));
      return response.data;
    },
    enabled: !!automationId,
  });
};

export default useRetrieveProjectRunStats;
